import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#005194",
    },
    secondary: {
      main: "#8791A4",
    },
  },
});

export default theme;
